// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const tfn: CountryValidator<"AU"> = createValidator(
  "au.tfn",
  14,
);

export default tfn;
export const compact = tfn.compact;
export const format = tfn.format;
export const validate = tfn.validate;
export const generate = (): string =>
  tfn.generate?.() ??
  (() => {
    throw new Error(
      "Validator au.tfn cannot generate values",
    );
  })();
